// extracted by mini-css-extract-plugin
module.exports = {"searchBtn":"SearchForm__searchBtn___1rpUv","searchWrapper":"SearchForm__searchWrapper___i0-y3"};